import * as PhosphorIcon from '@phosphor-icons/react'

export function Icon({ iconName, isButton, ...rest }) {
  const BaseIcon = PhosphorIcon[iconName]

  return (
    <BaseIcon
      style={{
        cursor: isButton ? 'pointer' : 'inherit',
      }}
      {...rest}
    />
  )
}
